// src/pages/WorksList.js
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Button,
    useMediaQuery,
    Breadcrumbs,
    Link as MuiLink,
} from '@mui/material';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../api/supabaseClient';

const WorksList = () => {
    const { t, i18n } = useTranslation();
    const { seriesId } = useParams();
    const navigate = useNavigate();
    const [works, setWorks] = useState([]);
    const isSmallUp = useMediaQuery('(min-width:600px)');

    useEffect(() => {
        const fetchWorks = async () => {
            let query = supabase
                .from('works')
                .select('id, title_en, title_tr, images(*)')
                .order('created_at', { ascending: false });

            if (seriesId) {
                query = query.eq('parent_id', seriesId);
            } else {
                query = query.is('parent_id', null);
            }

            const { data, error } = await query;
            if (error) {
                console.error('Works fetch error:', error);
                return;
            }
            setWorks(data || []);
        };
        fetchWorks();
    }, [seriesId]);

    return (
        <Box sx={{ p: 4 }}>
            {/*<Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>*/}
            {/*    <MuiLink*/}
            {/*        color="inherit"*/}
            {/*        underline="hover"*/}
            {/*        component="button"*/}
            {/*        onClick={() => navigate('/')}*/}
            {/*    >*/}
            {/*        {t('home')}*/}
            {/*    </MuiLink>*/}
            {/*    <Typography color="textPrimary">*/}
            {/*        {seriesId ? t('subWorks') : t('works')}*/}
            {/*    </Typography>*/}
            {/*</Breadcrumbs>*/}

            <Grid container spacing={4}>
                {works.map((work) => {
                    const coverImage = work.images[0]?.url || '';
                    const title = i18n.language === 'tr' ? work.title_tr : work.title_en;
                    const target = seriesId
                        ? `/works/${work.id}/detail`
                        : `/works/${work.id}`;

                    return (
                        <Grid item key={work.id} xs={12} sm={6} md={4}>
                            <Paper
                                elevation={3}
                                sx={{
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    height: isSmallUp ? 250 : 180,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    '&:hover .overlay': { bgcolor: 'rgba(0, 0, 0, 0.4)' },
                                }}
                                onClick={() => navigate(target)}
                            >
                                {coverImage ? (
                                    <Box
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            backgroundImage: `url(${coverImage})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                        }}
                                    />
                                ) : (
                                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'grey.200' }} />
                                )}
                                <Box
                                    className="overlay"
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        bgcolor: 'rgba(0, 0, 0, 0.2)',
                                        transition: 'bgcolor 0.2s',
                                    }}
                                />
                                <Typography
                                    variant={isSmallUp ? 'h5' : 'h6'}
                                    sx={{
                                        position: 'absolute',
                                        bottom: 16,
                                        left: 16,
                                        color: '#fff',
                                        fontWeight: 700,
                                        textShadow: '1px 1px 4px rgba(0,0,0,0.7)',
                                    }}
                                >
                                    {title}
                                </Typography>
                                <Button
                                    component={Link}
                                    to={target}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        top: 16,
                                        right: 16,
                                        bgcolor: 'rgba(255,255,255,0.8)',
                                        '&:hover': { bgcolor: 'rgba(255,255,255,1)' },
                                    }}
                                >
                                    {t('viewDetails')}
                                </Button>
                            </Paper>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default WorksList;